import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from '@angular/core';

import {
  InsertAdOfferRequest,
  CounterAdOfferRequest,
  AdOfferPriceRangeResponse
} from "@numizmat/services-models/core";
import {environment} from "@numizmat/environments";

@Injectable({
  providedIn: 'root'
})
export class AdOfferApiService {
  private httpClient: HttpClient = inject(HttpClient);

  private adOfferController: string = 'adOffer';

  public insertAdOffer(request: InsertAdOfferRequest): Observable<string> {
    const endpoint = `${environment.apiCoreUrl}/${this.adOfferController}`;
    return this.httpClient.post<string>(endpoint, request);
  }

  public getAdOfferPriceRange(adId: string): Observable<AdOfferPriceRangeResponse> {
    const endpoint = `${environment.apiCoreUrl}/${this.adOfferController}/price-range/${adId}`;
    return this.httpClient.get<AdOfferPriceRangeResponse>(endpoint);
  }

  public acceptAdOffer(adOfferId: string): Observable<number> {
    const endpoint = `${environment.apiCoreUrl}/${this.adOfferController}/accept/${adOfferId}`;
    return this.httpClient.patch<number>(endpoint, null);
  }

  public rejectAdOffer(adOfferId: string): Observable<number> {
    const endpoint = `${environment.apiCoreUrl}/${this.adOfferController}/reject/${adOfferId}`;
    return this.httpClient.patch<number>(endpoint, null);
  }

  public counterAdOffer(adOfferId: string, request: CounterAdOfferRequest): Observable<number> {
    const endpoint = `${environment.apiCoreUrl}/${this.adOfferController}/counter/${adOfferId}`;
    return this.httpClient.patch<number>(endpoint, request);
  }

  public acceptCounterAdOffer(adOfferId: string): Observable<number> {
    const endpoint = `${environment.apiCoreUrl}/${this.adOfferController}/counter/accept/${adOfferId}`;
    return this.httpClient.patch<number>(endpoint, null);
  }

  public rejectCounterAdOffer(adOfferId: string): Observable<number> {
    const endpoint = `${environment.apiCoreUrl}/${this.adOfferController}/counter/reject/${adOfferId}`;
    return this.httpClient.patch<number>(endpoint, null);
  }
}
